<template lang="pug">
#fonte
    el-collapse.mx-2
        el-collapse-item
            p(slot='title') {{ $t('mensagens.diagnosticoSocioambiental.fonteDosDados') }}

            p.mb-2 {{ $t('mensagens.diagnosticoSocioambiental.dataDeCadastro') }}: {{ fonte.dataCadastro || '-' }}
            p.mb-2 {{ $t('mensagens.diagnosticoSocioambiental.nome') }}: {{ fonte.nome || '-' }}
            p.mb-2 URL:
                a(v-for='(url, index) in urls'
                style='word-break: break-word;'
                :href='url', target='_blank') {{ ' ' + (url || '-') }}
</template>

<script>
export default {
    name: 'Fonte',

    data() {
        return {
            urls: []
        };
    },

    props: {
        fonte: {
            type: Object,
            required: true
        }
    },
    watch: {
        fonte: function () {
            this.listarFontes();
        }
    },
    mounted() {
        this.listarFontes();
    },
    methods: {
        listarFontes() {
            this.urls = [];
            this.urls = this.fonte.url.split('||');
        }
    }
};
</script>

<style lang="scss">
#fonte {
    margin-left: 13px;

    .el-icon-arrow-right {
        margin-top: -13px;
        margin-left: 5px;
    }

    .el-collapse-item__wrap {
        border: none;
    }

    .el-collapse-item__header {
        border-bottom: none;
    }

    p {
        line-height: 1;
    }
}
</style>
